import { BuyerLanding } from "@/components/BuyerLanding";

export default function CollisionManager() {
  return (
    <BuyerLanding
      testId="collision-manager-page"
      path="/for/collision-manager"
      seoTitle="Collision & Body Shop SOPs, Forms & Toolkit | Centennial"
      seoDescription="Document pre-existing damage, standardize repair plans and stay inspection-ready — processes, manager procedures and forms built for the body shop."
      eyebrow="For Collision & Body Shop Managers"
      headline="Run a body shop that documents every panel, every claim, every time."
      subhead="Independent shop or dealer collision center — the same rules apply. Document pre-existing damage, standardize repair plans, and stay inspection-ready with processes, manager procedures, and forms built for the shop."
      toolkitTitle="Your Body Shop toolkit"
      pains={[
        "\"That dent was already there\" arguments you can't win",
        "Supplements and disputes with no photos or documented condition",
        "Every estimator writing repair plans a different way",
        "Paint booth and OSHA safety gaps waiting to become a fine",
      ]}
      packs={[
        { id: "pack_damage", name: "Customer Vehicle Damage Pack", desc: "Kill \"that wasn't there\" disputes with documented condition, walk-arounds, and delivery acceptance." },
        { id: "pack_osha", name: "OSHA Safety Inspection Pack", desc: "Be inspection-ready with hazard reporting, evacuation, and shop safety checklists on file." },
      ]}
      browseLink={{ label: "Browse all 41 Body Shop forms", to: "/forms?dept=Body%20Shop" }}
    />
  );
}
